import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { OmniEmbedContainer } from '~/packages/omni/ui/OmniEmbedContainer';

export const AnalyticsView = (): React.ReactElement => {
  const { user } = useUserAuthOrThrow();

  return (
    <Flex
      direction="column"
      padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      id="analytics-route-container"
    >
      <Box h="100%" w="100%">
        <Flex justify="space-between" w="100%" mb="6">
          <Typography variant="page-title" trim>
            Analytics
          </Typography>
        </Flex>

        <OmniEmbedContainer
          organizationId={user.organization.id}
          height="calc(100vh - 200px)"
        />
      </Box>
    </Flex>
  );
};
